import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import connectUI from 'redux-ui';
import { uniq, flatMap } from 'lodash';
import {
  requestInstaller,
  requestInstallerPayRateUploads,
  requestPTOList,
  requestTravelingWorkDatesList,
} from 'actionCreators';
import Loading from 'components/Loading';
import InstallerDetailsCard from './components/installerDetailsCard';
import {
  getRole,
  getInstallerById,
  getHelperById,
  getCrewById,
  getWorkroomById,
  getSurfaceTypeById,
} from '../../../../reducers';
import { can } from '../../../../services';
import MessageBox from 'components/MessageBox';
import getPayRateUploadsData from './payRateUploads';
import PTOType from 'types/pto';
import { RoleType } from 'types/user';
import WorkroomType from 'types/workroom';


class InstallerDetails extends React.Component {
  constructor(props) {
    super(props);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount = () => Promise.all([
    this.props.requestInstaller(this.props.id),
    this.props.requestInstallerPayRateUploads(this.props.id),
    this.props.requestPTOList(this.props.id, 'installers'),
    this.props.requestTravelingWorkDatesList(this.props.id, 'installers'),
  ]);

  componentWillUnmount = () => (this.props.ui.successMessage ? this.props.updateUI('successMessage', '') : null);

  handleTabChange = tabIndex => this.props.updateUI('activeTab', tabIndex);

  render = () => {
    const { loading, installer, canEdit, helpers, crews, crewsSurfaceTypes,
      crewsWorkrooms, ui, payRateUploadsData, ptos, role, user, workrooms,
      travelingWorkDates } = this.props;
    return (<div>
      {ui.successMessage ? <MessageBox message={ui.successMessage} /> : null}
      {loading ? <Loading /> : <InstallerDetailsCard
        role={role}
        canEdit={canEdit}
        installer={installer}
        helpers={helpers}
        crews={crews}
        workrooms={workrooms}
        crewsWorkrooms={crewsWorkrooms}
        crewsSurfaceTypes={crewsSurfaceTypes}
        activeTab={ui.activeTab}
        onTabChange={this.handleTabChange}
        payRateUploadsData={payRateUploadsData}
        ptos={ptos}
        travelingWorkDates={travelingWorkDates}
        user={user}
      />}
    </div>);
  }
}

InstallerDetails.propTypes = {
  id: PropTypes.number,
  requestInstaller: PropTypes.func,
  ui: PropTypes.object,
  updateUI: PropTypes.func,
  loading: PropTypes.bool,
  installer: PropTypes.object,
  role: PropTypes.string,
  user: RoleType,
  canEdit: PropTypes.bool,
  crews: PropTypes.array,
  helpers: PropTypes.array,
  workrooms: PropTypes.arrayOf(WorkroomType),
  crewsWorkrooms: PropTypes.objectOf(PropTypes.arrayOf(WorkroomType)),
  crewsSurfaceTypes: PropTypes.object,
  requestInstallerPayRateUploads: PropTypes.func,
  requestPTOList: PropTypes.func,
  requestTravelingWorkDatesList: PropTypes.func,
  ptos: PropTypes.arrayOf(PTOType),
  travelingWorkDates: PropTypes.array,
  payRateUploadsData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    active: PropTypes.bool,
    uploadName: PropTypes.node,
    uploadedBy: PropTypes.string,
    uploadedOn: PropTypes.string,
    statusText: PropTypes.string,
  })),
};

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const installer = getInstallerById(state)[id];
  const helpers = (installer && installer.helpers ?
    (installer.helpers.map(helperId => getHelperById(state)(helperId))) : []);
  const crews = (installer && installer.crews ?
    (installer.crews.map(crewId => getCrewById(state)(crewId))) : []);
  const crewsWorkrooms = {};
  const crewsSurfaceTypes = {};
  crews.forEach((crew) => {
    crewsWorkrooms[crew.id] = crew.workrooms.map(wrId => getWorkroomById(state)(wrId));
    crewsSurfaceTypes[crew.id] = crew.surface_types.map(stId => getSurfaceTypeById(state)(stId));
  });
  const workrooms = uniq(flatMap(crewsWorkrooms));
  const role = getRole(state); // TODO: Obtain role from parent component
  return {
    id,
    installer,
    helpers,
    crews,
    crewsWorkrooms,
    crewsSurfaceTypes,
    workrooms,
    role,
    canEdit: can(role, 'update', 'installer') || can(role, 'update_basic', 'installer'),
    loading: installer ? installer.loading : true,
    payRateUploadsData: getPayRateUploadsData(state, id),
    ptos: state.ptos.data,
    travelingWorkDates: state.travelingWorkDates.data,
    user: state.user,
  };
};

export default connectUI()(connect(mapStateToProps, {
  requestInstaller, requestInstallerPayRateUploads, requestPTOList, requestTravelingWorkDatesList,
})(InstallerDetails));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/installerDetails.jsx